<template>
  <v-img class="align-end dialog-header white--text"
         gradient="to top, rgba(0, 0, 0, .82) 0%, rgba(0, 0, 0, .1) 60%, rgba(0, 0, 0, .3) 100%"
         height="220"
         v-bind:src="imageSrc">
    <v-btn class="dialog-header__close"
           dark
           icon
           v-bind:aria-label="closeLabel"
           v-on:click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <div class="align-center d-flex pa-4">
      <div class="dialog-header__avatar mr-4">
        <slot name="avatar" />
      </div>
      <div class="dialog-header__text">
        <p class="font-weight-bold mb-0 text-h5">{{ title }}</p>
        <p class="mb-0 text-subtitle-2">
          <slot name="subtitle" />
        </p>
      </div>
    </div>
  </v-img>
</template>

<script>
  export default {
    name: 'DialogHeader',
    props: {
      closeLabel: String,
      imageSrc: String,
      title: String
    }
  }
</script>

<style scoped>
  .dialog-header {
    flex: 0 0 auto;
  }

  /* Stays readable on bright as well as on dark images */
  .dialog-header__close {
    backdrop-filter: blur(6px);
    background: rgba(0, 0, 0, .45);
    position: absolute;
    right: 12px;
    top: 12px;
  }

  .dialog-header__avatar >>> .v-avatar {
    border: 2px solid #fff;
  }

  .dialog-header__text {
    min-width: 0;
    text-shadow: 0 1px 3px rgba(0, 0, 0, .5);
  }
</style>
